'use client';
const ErrorPage = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 140px)',
        padding: '2rem',
        textAlign: 'center',
      }}
    >
      <svg
        fill="none"
        height="132"
        viewBox="0 0 317 132"
        width="317"
        xmlns="http://www.w3.org/2000/svg"
        style={{ marginBottom: '2rem' }}
      >
        <path
          d="M128.312 41.2334C125.318 42.2989 123.332 45.1473 123.332 48.3292V110.3H201.205V48.3292C201.205 45.1546 199.219 42.3061 196.226 41.2334C193.479 40.2549 177.874 38.3777 162.269 38.3777C146.664 38.3777 131.059 40.2549 128.312 41.2334Z"
          fill="var(--purple-500)"
        />
        <path
          d="M192.855 108.162V50.2209"
          opacity="0.25"
          stroke="var(--gray-100)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="12"
        />
        <path
          d="M176.96 109.118L162.269 91.7229L176.96 74.335V109.118Z"
          fill="var(--purple-600)"
          opacity="0.45"
        />
        <path
          d="M162.269 38.3777C146.664 38.3777 131.059 40.2549 128.312 41.2334C125.318 42.2989 123.332 45.1473 123.332 48.3292V110.3H162.269V38.3849V38.3777Z"
          fill="var(--purple-600)"
          opacity="0.45"
        />
        <path
          d="M206.626 109.205H117.904V132H206.626V109.205Z"
          fill="var(--blue-400)"
        />
        <path
          d="M133.161 109.205H117.904V132H133.161V109.205Z"
          fill="var(--blue-600)"
          opacity="0.25"
        />
        <path
          d="M147.577 74.3279L162.269 91.7231L147.577 109.111V74.3279Z"
          fill="var(--purple-500)"
        />
        <path
          d="M162.117 30.1003V3.85522"
          stroke="var(--purple-500)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="6"
        />
        <path
          d="M115.57 49.1409L101.726 45.4299"
          stroke="var(--purple-500)"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M209.656 49.3149L224 45.4299"
          stroke="var(--purple-500)"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M132.885 32.7316L120.883 16.8657"
          stroke="var(--purple-500)"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M191.406 32.7316L203.329 16.8657"
          stroke="var(--purple-500)"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.7688 107.71H45.9288V131.5H62.4388V107.71H74.3988V93.8002H62.4388V39.2002H42.5488L2.7688 97.4402V107.71ZM20.4488 93.8002V93.5402L41.7688 64.0302C44.2388 60.5202 46.3188 55.5802 46.3188 55.5802H46.5788C46.5788 55.5802 45.9288 60.6502 45.9288 65.2002V93.8002H20.4488Z"
          fill="var(--purple-600)"
        />
        <path
          d="M242 108.01H285.16V131.8H301.67V108.01H313.63V94.1H301.67V39.5H281.78L242 97.74V108.01ZM259.68 94.1V93.84L281 64.33C283.47 60.82 285.55 55.88 285.55 55.88H285.81C285.81 55.88 285.16 60.95 285.16 65.5V94.1H259.68Z"
          fill="var(--purple-600)"
        />
      </svg>

      <h2 style={{ color: 'var(--ink)', marginTop: '1rem' }}>
        Sorry, we can&apos;t find that page.
      </h2>
    </div>
  );
};

export default ErrorPage;
